import { FC } from 'react';

import { Section, SectionContent, SectionItem, SectionTitle } from './atoms';
import { CampaignDetail, SenderId } from '@/apis/core';
import { humanize, humanizeSenderIdType } from '@/utils/string';

interface SenderIdSectionProps {
  campaign: CampaignDetail;
  senderId?: SenderId;
}

const formatBooleanAttribute = (value: boolean) => (value ? 'Yes' : 'No');

const SenderIdSection: FC<SenderIdSectionProps> = ({ campaign, senderId }) => (
  <Section>
    <SectionTitle>Sender ID</SectionTitle>
    <SectionContent>
      <SectionItem title="Sender ID">{senderId?.senderIdValue}</SectionItem>
      <SectionItem title="Routing Mode">
        {humanize(senderId?.routingMode)}
      </SectionItem>
      <SectionItem title="Sender ID type">
        {humanizeSenderIdType(senderId?.senderIdType)}
      </SectionItem>
      <SectionItem title="Off-Net Outbound Traffic Termination">
        {formatBooleanAttribute(campaign.offNetOutboundTerminationSupported)}
      </SectionItem>
      <SectionItem title="International Inbound Termination for A2P SMS">
        {formatBooleanAttribute(campaign.intlInboundTerminationSupported)}
      </SectionItem>
      <SectionItem title="International Outbound Termination for A2P SMS">
        {formatBooleanAttribute(campaign.intlOutboundTerminationSupported)}
      </SectionItem>
      <SectionItem title="On-Net Inbound Traffic Termination">
        {formatBooleanAttribute(campaign.onNetInboundTerminationSupported)}
      </SectionItem>
      <SectionItem title="Off-Net Inbound Traffic Termination">
        {formatBooleanAttribute(campaign.offNetInboundTerminationSupported)}
      </SectionItem>
    </SectionContent>
  </Section>
);

export default SenderIdSection;
